import { useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { scrollToId } from "./scroll";

// Scrolls to a section id. If the id exists on the current page, scrolls
// locally; otherwise navigates home first and then scrolls to the section.
export function useSectionNav() {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  return useCallback(
    (id) => (e) => {
      e?.preventDefault?.();
      if (document.getElementById(id)) {
        scrollToId(id);
        return;
      }
      if (pathname !== "/") {
        navigate("/");
        setTimeout(() => scrollToId(id), 150);
      }
    },
    [navigate, pathname]
  );
}
